import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/suppliers',
        name: 'suppliers.index',
        component: () => import('./pages/suppliers/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/suppliers/:id',
        name: 'supplier.show',
        component: () => import('./pages/suppliers/Show.vue'),
        meta: {
            layout: 'app',
            navigation: {
                suppliers: {
                    name: 'suppliers.index',
                },
            },
        },
        children: [
            {
                path: 'branches/:branchId',
                name: 'supplier.show.branch',
                component: () => import('./pages/suppliers/ShowBranch.vue'),
                meta: {
                    layout: 'app',
                },
            },
        ],
    },
    {
        path: '/supplierbranches',
        name: 'supplierbranches.index',
        component: () => import('./pages/supplierbranches/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/supplierbranches/:id',
        name: 'supplierbranch.show',
        component: () => import('./pages/supplierbranches/Show.vue'),
        meta: {
            layout: 'app',
            navigation: {
                supplierbranches: {
                    name: 'supplierbranches.index',
                },
            },
        },
    },
    {
        path: '/products',
        name: 'products.index',
        component: () => import('./pages/products/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/products/:id',
        name: 'product.show',
        component: () => import('./pages/products/Show.vue'),
        meta: {
            layout: 'app',
            navigation: {
                products: {
                    name: 'products.index',
                },
            },
        },
        children: [
            {
                path: 'details',
                name: 'product.show.details',
                component: () => import('./pages/products/show/Details.vue'),
                meta: { layout: 'app' },
            },
            {
                path: 'categories',
                name: 'product.show.categories',
                component: () =>
                    import('./pages/products/show/ProductCategories.vue'),
                meta: { layout: 'app' },
            },
            {
                path: 'suppliers',
                name: 'product.show.suppliers',
                component: () =>
                    import('./pages/products/show/Supplierbranches.vue'),
                meta: { layout: 'app' },
            },
            {
                path: 'refinement',
                name: 'product.show.refinement',
                component: () =>
                    import('./pages/products/show/ProductPredicates.vue'),
                meta: { layout: 'app' },
            },
        ],
    },
] satisfies RouteRecordRaw[];
